/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Reset_ButtonInputs */



/**
* | output |
* | --- |
* | "Reset Form" |
*
* @param {Event_Group_Metadata_Reset_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_reset_button = /** @type {((inputs?: Event_Group_Metadata_Reset_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Reset_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réinitialiser le formulaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Formular zurücksetzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modulo di ripristino")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сбросить форму")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restablecer formulario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重置表单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォームをリセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ॉर्म रीसेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Redefinir formulário")
	return /** @type {LocalizedString} */ ("Reset Form")
});